﻿import axios from 'axios';
import {APIUrl} from '../constants/ApplicationConstants.js';
import InvestmentAllocationActions from '../actions/InvestmentAllocationActions.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';
import ErrorHandler from '../core/ErrorHandler.js';

﻿module.exports = {
    getModelPortfolioList: function(productId, selectMessage, noPortfolioMessage) {
﻿        const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.MODEL_PORTFOLIO_LIST + '?newInvestor=false';
﻿        axios.get(url)
﻿            .then(ThrowIfStatusNotOk)
﻿            .then((response) => {
﻿                const data = response.data || [];
                const msg = data.length > 0 ? selectMessage : noPortfolioMessage;

﻿                InvestmentAllocationActions.receiveModelPortfolioList(data, msg);
﻿            })
﻿            .catch((error) => {
                InvestmentAllocationActions.receiveModelPortfolioList([], noPortfolioMessage);
﻿                // do not throw here
﻿                ErrorHandler.logError(Error('Get Model Portfolio List', error));
﻿            });
﻿    },

﻿    // Load investment option list into InvestmentOptionStore via Action
﻿    getInvestmentOptionList: function(productId) {
﻿        const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.INVESTMENT_OPTION_LIST;

﻿        axios.get(url)
﻿            .then(ThrowIfStatusNotOk)
﻿            .then((response) => {
﻿                InvestmentAllocationActions.receiveInvestmentOptionList(response.data);
            })
﻿            .catch((error) => {
﻿                throw Error('Investment Options List', error);
﻿            });
﻿    }
﻿};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/InvestmentAllocationAPI.js